/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `commited_elsewhere` - Currently committed to other opportunities
 * * `will_not_pass_clearance` - Currently working with Organization, will not name clear
 * * `block_organization` - I do not ever want to work for this Organization
 * * `block_facility` - I do not ever want to work at this Facility
 * * `block_state` - I do not want to work in this State
 * * `facility_too_far_away` - Facility is too far away
 * * `facility_reputation` - Facility reputation
 * * `not_enough_facility_details` - Not enough facility details
 * * `not_interested` - Not interested
 * * `rates_too_low` - Rates are too low
 * * `other` - Other
 */
export enum ProviderRejectionReasonEnum {
    COMMITED_ELSEWHERE = 'commited_elsewhere',
    WILL_NOT_PASS_CLEARANCE = 'will_not_pass_clearance',
    BLOCK_ORGANIZATION = 'block_organization',
    BLOCK_FACILITY = 'block_facility',
    BLOCK_STATE = 'block_state',
    FACILITY_TOO_FAR_AWAY = 'facility_too_far_away',
    FACILITY_REPUTATION = 'facility_reputation',
    NOT_ENOUGH_FACILITY_DETAILS = 'not_enough_facility_details',
    NOT_INTERESTED = 'not_interested',
    RATES_TOO_LOW = 'rates_too_low',
    OTHER = 'other',
}
